@if (searchComplete && possibleDuplicatesFound) {
  <mat-expansion-panel color="accent">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ duplicateMessage }}</mat-panel-title>
    </mat-expansion-panel-header>
    <phscw-grid
      #gridClearingDuplicates
      [gridId]="gridId"
      [simpleGrid]="true"
      [gridData]="possibleDuplicatesData"
      [gridColumns]="gridColumns"
      [gridDisplayedColumns]="gridDisplayedColumns">
    </phscw-grid>
    <!-- Buttons Submit & Cancel -->
    <div class="cw-button-wrapper">
      @if (this.entity.id === 0) {
        <button
          mat-raised-button
          color="accent"
          type="button"
          [disabled]="saving"
          (click)="clickCancel()">
          {{ buttonCancel }}
        </button>
      }
      @if (this.entity.id === 0) {
        <button
          mat-raised-button
          color="accent"
          type="button"
          [disabled]="selectedDuplicate === null || saving"
          (click)="clickSelect()">
          {{ buttonSelect }}
        </button>
      }
      @if (this.entity.id === 0 && moveButtonVisible) {
        <button
          mat-raised-button
          color="accent"
          type="button"
          [disabled]="selectedDuplicate === null || saving"
          (click)="clickEdit('move_main_institution_id')">
          {{ buttonMove }} <span [ngClass]="saving ? 'icon-spinner icon-spin' : ''"></span>
        </button>
      }
      @if (this.entity.id === 0 && copyButtonVisible) {
        <button
          mat-raised-button
          color="accent"
          type="button"
          [disabled]="selectedDuplicate === null || saving"
          (click)="clickEdit('add_secondary_institution_id')">
          {{ buttonCopy }} <span [ngClass]="saving ? 'icon-spinner icon-spin' : ''"></span>
        </button>
      }
      @if (this.entity.id > 0 && allowMergeEntities) {
        <button
          mat-raised-button
          color="accent"
          class="cw-merge-button"
          type="button"
          [disabled]="selectedDuplicate === null || saving"
          (click)="clickMerge()">
          {{ buttonMerge }}
        </button>
      }
    </div>
  </mat-expansion-panel>
}

@if (enableUniquemessage && searchComplete && entity.id > 0 && !possibleDuplicatesFound) {
  <mat-expansion-panel
    color="accent"
    [hideToggle]="true"
    [disabled]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>{{ uniqueMessage }}</mat-panel-title>
    </mat-expansion-panel-header>
  </mat-expansion-panel>
}
